import { del, get, post, put } from '../utility/http';
import { AssetType, Point } from '../model/infrastructureInterfaces';


//const base_url = 'https://cer-portal-dev.grupposistematica.it/infrastructure-management';
//const getAllPath = true;
const base_url =  '/infrastructure-management';
const getAllPath = false;

export const getLayersDTO = async (polygonReq: Point[] | undefined, context: string) => {
  try {
    const response = await post(
      `${base_url}/ctx/${context}/layers`,
      true,
      {},
      polygonReq?{'points' : polygonReq}:{},
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};

export const getAssetTypesDTO = async () => {
  try {
    const response = await get(
      `${base_url}/asset_type`,
      true,
      {},
      getAllPath,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};


export const getActionsByAssetTypesDTO =
  async (selectedAssetType: AssetType) => {
    try {
      const response = await get(
        `${base_url}/asset_type/${selectedAssetType.id}/action`,
        true,
        {},
        getAllPath,
        true
      );
      return response;
    } catch (e: any) {
      return Promise.reject(e.response ? e.response : e);
    }
  };

export const getAssetsByLayerDTO = async ({
  context,
  infrastructureId
}: {
  context: string,
  infrastructureId: number
}) => {
  try {
    const response = await get(
      `${base_url}/ctx/${context}/layer/${infrastructureId}/asset`,
      true,
      {},
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};


export const getLayerDTOById = async ({
  context,
  layerId 
}: {
  context: string;
  layerId: number; 
}) => {
  try {
    const response = await get(
      `${base_url}/ctx/${context}/layer/${layerId}`,
      true,
      {}, 
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};



export const getAssetsLayerDTOById = async ({
  context,
  layerId 
}: {
  context: string;
  layerId: number; 
}) => {
  try {
    const response = await get(
      `${base_url}/ctx/${context}/layer/${layerId}/asset`,
      true,
      {}, 
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};



export const swapOrder = async ({
  context,
  layerId,
  id1,
  id2
}: {
  context: string;
  layerId: number; 
  id1: number;
  id2: number;
}) => {
  try {
    const response = await post(
      `${base_url}/ctx/${context}/layer/${layerId}/asset/swap-order`,
      true,
      {}, 
      {id1: id1, id2: id2},
      getAllPath,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};

export const postLayerDTO = async ({
  context,
  layerId,
  body
}: {
  context: string;
  layerId: number|undefined;
  body: any;
}) => {
  try {
    const response = await post(
      `${base_url}/ctx/${context}/layer${layerId?'/':''}${layerId?(layerId):''}`,
      true,
      {},
      body,
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};



export const saveAssetTypeDTO = async ({
  assetTypeId,
  name, 
  description,
  type,
  actions
}: { 
  assetTypeId: number|undefined;
  name: string;
  description: string;
  type: string;
  actions: any[];
}) => {
  try {

    
    const body: any =  {name: name, 
      description: description,
      type: type 
    };

    const response: any = assetTypeId?await put(
      `${base_url}/asset_type/${assetTypeId}`,
      true,
      {},
      body,
      getAllPath
    ):await post(
      `${base_url}/asset_type`,
      true,
      {},
      body,
      getAllPath
    );

    console.log(response);
    const assetId = response?.data?.id;
    


    await post(
      `${base_url}/asset_type/${assetId}/action`,
      true,
      {},
      {actionTypes:actions},
      getAllPath
    ); 

    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};




export async function deleteAssetTypeDTO({
  assetTypeId  
}: { 
  assetTypeId: number; 
}) {
  try {
    
    const response = await del(
      `${base_url}/asset_type/${assetTypeId}`,
      true,
      {},
      {},
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}


export const postAssetDTO = async ({
  context,
  infrastructureId,
  assetId,
  body,
  owner
}: {
  context: string;
  owner: string;
  infrastructureId: number;
  assetId?: number;
  body: any;
}) => {
  try {
    let url = `${base_url}/ctx/${context}/layer/${infrastructureId}/asset`;
    if (assetId){
      url += `/${assetId}`;
    }
    const response = await post(url,
      true,
      {},
      {...body, owner: owner},
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};

export async function deleteLayerDTOById({
  context,
  infrastructureId,
  forceDelete
}: {
  context: string;
  infrastructureId: number;
  forceDelete:boolean;
}) {
  try {
    const response = await del(
      `${base_url}/ctx/${context}/layer/${infrastructureId}?forceDelete=${forceDelete}`,
      true,
      {},
      {},
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function deleteAssetDTO({
  context,
  infrastructureId,
  assetId
}: {
  context: string;
  infrastructureId: number;
  assetId: number;
}) {
  try {
    const response = await del(
      `${base_url}/ctx/${context}/layer/${infrastructureId}/asset/${assetId}`,
      true,
      {},
      {},
      getAllPath
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}


 
export const importInfrastructureToUser = async ({ 
  body,
  context,
  force
}: {
  body:any; 
  context:string;
  force: boolean;
}) => {
  try {
    const response = await post(
      `${base_url}/ctx/${context}/layer/upload/kml?forceUpload=${force}`,
      true,
      {},
      body,
      getAllPath,
      true,
      'multipart/form-data',
      300000
    );
    return response; 
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};


export const downloadFileAsync = async ({
  context,
  layerId
}: {
  context: string;
  layerId: number;
}) => {
  try {
    const response = await get(

      `${base_url}/ctx/${context}/layer/${layerId}/download`,
      true,
      {},
      getAllPath,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};

